import React from 'react';
import ContextualAIChat from './ContextualAIChat';

const CollapsibleChat = ({ predictionData, isOpen, onClose }) => {
  return (
    <div className={`h-full bg-white shadow-lg transition-all duration-300 ease-in-out ${isOpen ? 'w-full' : 'w-0'} overflow-hidden`}>
      <div className="p-4 h-full flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">AI Assistant</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-grow overflow-hidden">
          <ContextualAIChat predictionData={predictionData} />
        </div>
      </div>
    </div>
  );
};

export default CollapsibleChat;